import { call, put, takeEvery } from 'redux-saga/effects';
import Api from '../../utils/Api';

export default function getCustomSagas(actions, constants) {
  function* checkSeafarerUniqueness({ payload }) {
    try {
      const { data } = yield call(Api.users.checkSeafarerUniqueness, payload);
      yield put(actions.checkSeafarerUniquenessSuccess(data));
    } catch (e) {
      console.error('Seafarer preexistence check error:', e);
      yield put(actions.checkSeafarerUniquenessError(e));
    }
  }

  function getFeatureSagas() {
    return [
      takeEvery(constants.CHECK_SEAFARER_UNIQUENESS_REQUEST, checkSeafarerUniqueness),
    ];
  }

  return getFeatureSagas;
}

